export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14785.be912877.jpg";